import React, { Component } from 'react';
import {Form as AForm} from 'antd';
import PropTypes from 'prop-types';

const FormItem = AForm.Item;

class Form extends Component {
    constructor (props) {
        super(props);
    }

    componentDidMount () {
        let {onRef, form} = this.props;
        if (onRef) {
            this.props.onRef(form);
        }
    }

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        });
    }

    render () {
        let {children, form, hideRequiredMark, layout, button, formItemLayout} = this.props,
            {getFieldDecorator} = form,
            formObj = {onSubmit: this.handleSubmit};
        if (hideRequiredMark) {
            formObj.hideRequiredMark = hideRequiredMark;
        }
        if (layout) {
            formObj.layout = layout;
        }
        return (
            <AForm {...formObj}>
                {children.map((node, i) => {
                    if (node.formItemLayout) formItemLayout = node.formItemLayout;
                    return (
                        <FormItem
                            {...formItemLayout}
                            label={node.label}
                            key={i}
                        >
                            {getFieldDecorator(node.name, node.options || {})(node.component)}
                        </FormItem>
                    );
                })}
                {button}
            </AForm>
        );
    }
}

Form.propTypes = {
    formItemLayout: PropTypes.object,
    hideRequiredMark: PropTypes.bool,
    layout: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onRef: PropTypes.func,
    button: PropTypes.element.isRequired,
}

export default AForm.create()(Form);



// WEBPACK FOOTER //
// ./src/components/Form.jsx